import { render } from "./HiMessage.vue?vue&type=template&id=016cba4a&scoped=true"
import script from "./HiMessage.vue?vue&type=script&lang=js"
export * from "./HiMessage.vue?vue&type=script&lang=js"

import "./HiMessage.vue?vue&type=style&index=0&id=016cba4a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016cba4a"]])

export default __exports__